import {sidebarState} from "../utils/sidebarState";

export const drugNdrop = {
  mixins: [sidebarState],
  data() {
    return {
      currentDroppable: null,
      movedEl: '',
      movedX: '',
      movedY: '',
      movedGroup: '',
      motherRole: '',
      thingType: '',

      //NEW
      draggedEl: '',
      deltaX: '',
      deltaY: '',
      dragX: '',
      dragY: '',
      hiddenEl: false,
      checkedFlag: false,

      // массив позиций елементов для мультидрага
      multiDragXY: []
    }
  },
  methods: {
    removeAllHandlers() {
      let elems = document.querySelectorAll('.moved_class');
      for (let i = 0; i < elems.length; i++) {
        elems[i].classList.remove('moved_class');
        elems[i].style.left = 0;
        elems[i].style.top = 0;
      };
      let elemsDrop = document.querySelectorAll(`.${this.drugConfig.dropActive}`);
      for (let i = 0; i < elemsDrop.length; i++) {
        elemsDrop[i].classList.remove(this.drugConfig.dropActive)
      };

      this.movedEl ='';
      this.movedX = '';
      this.movedY = '';
      this.draggedEl = '';
      this.deltaY = '';
      this.deltaX = '';
      this.dragX = '';
      this.dragY = '';
      this.multiDragXY = [];
    },
    clearAll() {
      this.movedGroup = '';
      this.thingType = '';
      this.movedEl = '';
    },

    //положение курсора на экране
    //нужно для смещения относительно элемента
    setDelta(e) {
      this.deltaX = e.clientX;
      this.deltaY = e.clientY;
    },
    //начало перетаскивания
    dragStart(item,evt,config) {
      evt.preventDefault();
      if (this.$route.name !== 'journal' && this.$route.name !== 'journalThingsInProject' && this.$route.name !== 'journalThingsInProjectItem') {
        // if (item.virtual === false) {
          //получаем элемент
          let ref = `${config.refName}${item.id}`;
          let elem = this.$refs[ref][0];

          let checkedRef = '';
          let checkedElem = {};

          this.checkedFlag = false

          if (elem) {
            //получаем координаты элемента
            this.movedX = this.deltaX - elem.getBoundingClientRect().left;
            this.movedY = this.deltaY - elem.getBoundingClientRect().top + config.y;

            //учитывая при этом сайдбар
            if (this.sidebarOpen) {
              this.movedX += +config.fullX
            } else {
              this.movedX += +config.closedX
            };
            //добавляем класс для визуала
            if (this.checkedItems.length > 0) {
              this.checkedItems.forEach((checkedItem) => {
                if (checkedItem.id === item.id) {
                  this.checkedFlag = true
                }
              })
            } else {
              this.checkedFlag = false
            }
            setTimeout(() => {
              if (this.checkedItems.length > 0 && this.checkedFlag === true) {
                this.checkedItems.forEach((checkedItem) => {
                  this.multiDragXY.push({ dragX: '', dragY: '' })
                  checkedRef = `${config.refName}${checkedItem.id}`;
                  checkedElem = this.$refs[checkedRef][0];
                  checkedElem.classList.add('moved_class-opacity')
                })
              }
              if (this.checkedFlag === false) {
                this.multiDragXY.push({ dragX: '', dragY: '' })
                elem.classList.add('moved_class-opacity')
              }
            }, 0);
            //записываем элемент в стэйт
            if (this.checkedItems.length > 0 && this.checkedFlag === true) {
              this.draggedEl = this.checkedItems;
            }
            if (this.checkedFlag === false) {
              this.draggedEl = [item];
            }
          };

          //отслеживаем перемещение мыши
          document.addEventListener('mousemove', this.mouseMove)
        // }
      }
    },
    mouseMove(e,config) {
      //двигаем элемент
      let shiftX = this.movedX;
      let posX = e.pageX - shiftX;

      let shiftY = this.movedY;
      let posY = e.pageY - shiftY;

      this.dragX = posX;
      this.dragY = posY;

      let itemHeight = 0

      if (this.checkedItems.length > 0 && this.checkedFlag === true) {
        this.checkedItems.forEach((item, index) => {
          this.multiDragXY[index].dragX = posX
          this.multiDragXY[index].dragY = posY + itemHeight
          itemHeight += 60
        })
      } else {
        this.multiDragXY[0].dragX = posX
        this.multiDragXY[0].dragY = posY
      }

      // получаем скрытый элемент
      // let hiddenEl = this.$refs.hiddenEl;
      // hiddenEl.classList.add('hiddenClass');
      let hiddenEls = document.querySelectorAll('.hidden-element')
      hiddenEls.forEach((item) => {
        item.classList.add('hiddenClass');
      })

      //элемен под перемещаемым
      let elemBelow = document.elementFromPoint(e.clientX, e.clientY);
      // hiddenEl.classList.remove('hiddenClass');
      hiddenEls.forEach((item) => {
        item.classList.remove('hiddenClass');
      })

      if (!elemBelow) return;
      let droppableBelow = elemBelow.closest(this.drugConfig.dropzone);

      if (this.currentDroppable != droppableBelow) {
        if (this.currentDroppable) {
          //вылет
          this.leaveGroup()
        };
        this.currentDroppable = droppableBelow
        if (this.currentDroppable) {
          //вход
          if (this.currentDroppable.classList.contains('item-blocked')) {
            return;
          };
          this.enterGroup()
        }
      }

    },
    leaveGroup() {
      let elem = this.currentDroppable;
      if (elem) {
        elem.classList.remove(this.drugConfig.dropActive);
        this.movedGroup = false;
      }
    },
    enterGroup() {
      let elem = this.currentDroppable;

      if (this.isRoles) {
        if (elem.classList.contains(this.drugConfig.groupClass)) {
          elem.classList.add(this.drugConfig.dropActive);
        }
      };

      if (this.isThings) {
        //let drugType = this.draggedEl.type;
        // if (this.draggedEl.virtual === false) {
          if (elem.classList.contains(this.drugConfig.groupClass)) {
            elem.classList.add(this.drugConfig.dropActive);
          }
        // } else if (this.draggedEl.virtual === true) {
        //   let elemAttr = elem.getAttribute('data-type');
        //   if (elemAttr !== 'virtual') {
        //     if (elem.classList.contains(this.drugConfig.groupClass)) {
        //       elem.classList.add(this.drugConfig.dropActive);
        //     }
        //   }
        // };
      };
      let id = elem.getAttribute(this.drugConfig.attr);
      this.movedGroup = id;
    },
  }
}
